module.exports = __webpack_public_path__ + "static/img/ent-74.a94b5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-74.jpg
// module id = I9+i
// module chunks = 51